import React from "react";
import PropTypes from "prop-types";
import ReadpointSelector from "../../readpoint/component/ReadpointSelector";

class IntegrationPolygonForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {setValue: props.setValue, entity: props.defaultValue};
  }

  onChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.setState({isIntegrated: value});
  }

  render() {
    const {entity = {}, setValue} = this.state;
    console.log('entity: ', entity['READPOINT_ID']);
    return (<div>
      <ReadpointSelector defaultValue={entity['READPOINT_ID']} setValue={setValue}/>
    </div>);
  }

}

IntegrationPolygonForm.propTypes = {
  defaultValue: PropTypes.object,
  setValue: PropTypes.func
};

export default IntegrationPolygonForm;



// WEBPACK FOOTER //
// ./src/checkpoint/integration/IntegrationPolygonForm.js